

























import Vue, { PropType } from 'vue';

import { DynamicDocumentItem, DynamicDocumentItemData, ValidationRule } from '@/types';
import { isItemRequired } from '@/utilities';

export default Vue.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    data: Object as PropType<DynamicDocumentItemData>,
    documentData: Array as PropType<DynamicDocumentItemData[]>,
  },

  computed: {
    isRequired(): boolean {
      return isItemRequired(this.item, this.documentData ?? [this.data]);
    },

    meta(): Record<string, any> {
      return this.item.meta ?? {};
    },

    rules(): ValidationRule[] {
      return [
        (val: string) => !this.isRequired || !!val || this.$t('validation.general.required'),
      ];
    },
  },
});
